import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <div className="not-found-hero">
          <div className="not-found-404">404</div>
          <h1 className="not-found-title">Ops! Página não encontrada</h1>
          <p className="not-found-description">
            A página que você está procurando não existe ou foi movida.
          </p>
        </div>

        <div className="not-found-about">
          <div className="not-found-about-icon">
            <img
              src="/images/logo-confereai.png"
              alt="ConfereAí"
              className="not-found-logo"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          </div>
          <p className="not-found-about-text">
            O <strong>ConfereAí</strong> é um sistema inteligente de conferência de cargas e veículos.
            Automatize seus processos logísticos com leitura de etiquetas, monitoramento em tempo real
            e dashboards de performance para sua operação.
          </p>
        </div>

        <div className="not-found-logins">
          <h2 className="not-found-logins-title">Acesse o sistema</h2>
          <p className="not-found-logins-subtitle">Escolha o tipo de acesso adequado ao seu perfil:</p>

          <div className="not-found-login-cards">
            <button
              className="not-found-login-card not-found-login-admin"
              onClick={() => navigate('/login')}
            >
              <div className="not-found-card-icon">{'\uD83C\uDFE2'}</div>
              <h3>Transportadora</h3>
              <p>Acesso administrativo para gestores e operadores da transportadora.</p>
            </button>

            <button
              className="not-found-login-card not-found-login-conferente"
              onClick={() => navigate('/conferente/login')}
            >
              <div className="not-found-card-icon">{'\uD83D\uDCF1'}</div>
              <h3>Conferente</h3>
              <p>Acesso para conferentes realizarem leituras e conferências de carga.</p>
            </button>

            <button
              className="not-found-login-card not-found-login-cliente"
              onClick={() => navigate('/cliente/login')}
            >
              <div className="not-found-card-icon">{'\uD83D\uDCCA'}</div>
              <h3>Cliente</h3>
              <p>Dashboard de performance para clientes acompanharem suas cargas.</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
